/**
 * Validates a group name from the Create Group dialog.
 * Returns a human-readable error string, or null when the name is acceptable.
 * Empty / whitespace-only names are rejected (the value is trimmed before
 * insert, so a blank name would otherwise produce an empty group_name).
 */
export function validateGroupName(name: string): string | null {
  if (!name.trim()) {
    return 'Group name is required';
  }
  return null;
}
